import { Steps } from "@/models/LeadsState";

export const STEP_COMP_NAMES = { 
	PLANS_WRAPPER: 'PlansWrapper',
	PAYMENT: 'Payment',
	THANK_YOU: 'ThankYou'
}

const leadsConstants = { 
	PLANS_BG_IMAGES: [
		require('@/assets/images/leads/plans-bg/plan-bg.svg'),
		require('@/assets/images/leads/plans-bg/plan-bg1.svg'),
		require('@/assets/images/leads/plans-bg/plan-bg2.svg'),
		require('@/assets/images/leads/plans-bg/plan-bg3.svg')
	],
	STEPS_COMP: { 
		[Steps.SELECT_PLAN]: STEP_COMP_NAMES.PLANS_WRAPPER,
		[Steps.PAYMENT]: STEP_COMP_NAMES.PAYMENT,
		[Steps.THANK_YOU]: STEP_COMP_NAMES.THANK_YOU
	},
	STEP_COMP_NAMES,
	LEADS_PLANS_TO_SHOW: {
		DEFAULT: [1, 2, 3, 5],
		NO_REMAINING_LEADS: [6, 2, 3]
	}
}

export default leadsConstants;
